export default __webpack_public_path__ + "static/media/dashboards-tile.1dbade53.svg";